import { render, staticRenderFns } from "./EndorsementQuotation.vue?vue&type=template&id=60fc1b2e&scoped=true"
import script from "./EndorsementQuotation.vue?vue&type=script&lang=js"
export * from "./EndorsementQuotation.vue?vue&type=script&lang=js"
import style0 from "./EndorsementQuotation.vue?vue&type=style&index=0&id=60fc1b2e&prod&lang=scss"
import style1 from "./EndorsementQuotation.vue?vue&type=style&index=1&id=60fc1b2e&prod&scoped=true&lang=css"
import style2 from "./EndorsementQuotation.vue?vue&type=style&index=2&id=60fc1b2e&prod&lang=scss&scoped=true"
import style3 from "./EndorsementQuotation.vue?vue&type=style&index=3&id=60fc1b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc1b2e",
  null
  
)

export default component.exports